module.exports = __webpack_public_path__ + "img/langHam.178ba48b.png";